import React, { useRef } from 'react';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import ApprovalLimitsTable from './components/ApprovalLimitsTable';
import ApprovalLimitsForm from './components/ApprovalLimitsForm';
import ApprovalLimitsFilter from './components/ApprovalLimitsFilter';
import ApprovalHistoryDialog from '../approval-groups/components/ApprovalHistoryDialog';
import { useGetApprovalLimitByIdQuery } from '../../../../api/endpoints/approvalLimits';
import useApprovalLimits from './hooks/useApprovalLimits';
import { useLanguage } from '../../../../contexts/LanguageContext';

const ApprovalLimitsPage = () => {
    const { th } = useLanguage();
    
    const {
        toast,
        tableProps,
        formProps,
        dialogVisible,
        historyDialogVisible,
        setHistoryDialogVisible,
        historySelectedItem,
        filterFields,
        customFilterTypes,
        customFilterOptions,
        handleSearch,
        handleResetFilters,
        handleApplyFilters,
        setDialogVisible,
        openNewDialog
    } = useApprovalLimits();

    const handleDialogHide = () => {
        setDialogVisible(false);
    };

    const handleHistoryDialogHide = () => {
        setHistoryDialogVisible(false);
    };

    const columnsRef = useRef(null);

    return (
        <div className="card">
            <Toast ref={toast} />

            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('approvalLimits.title')}</h1> 
                <Button label={th('common.new')} icon="pi pi-plus" onClick={openNewDialog} />
            </div> 

            <ApprovalLimitsFilter
                filterFields={filterFields}
                columns={columnsRef.current}
                customFilterTypes={customFilterTypes}
                customFilterOptions={customFilterOptions}
                handleSearch={handleSearch}
                handleApplyFilters={handleApplyFilters}
                handleResetFilters={handleResetFilters}
            />

            <ApprovalLimitsForm {...formProps} visible={dialogVisible} onHide={handleDialogHide} />

            <ApprovalHistoryDialog 
                visible={historyDialogVisible} 
                onHide={handleHistoryDialogHide}
                selectedItem={historySelectedItem}
                useGetByIdQuery={useGetApprovalLimitByIdQuery}
            />

            <ApprovalLimitsTable {...tableProps} />
        </div>
    );
};

export default ApprovalLimitsPage; 